var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDelete48Filled = function SvgIconDelete48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.07 14.3h-7v-2.1a2.91 2.91 0 0 0-2.9-2.9H20.9a2.9 2.9 0 0 0-2.9 2.9v2.1h-7v3.4h1.3v15.7a5.31 5.31 0 0 0 5.3 5.3h12.8a5.31 5.31 0 0 0 5.3-5.3V17.7H37l.07-3.4Zm-15.63-1.6h5.26v1.6h-5.26v-1.6Zm1.33 17.8h-3.4v-8h3.4v8Zm6 0h-3.4v-8h3.4v8Z",
    fill: "current"
  })));
};
export default SvgIconDelete48Filled;